import React from 'react'

//Style the 404 page
function NoPage() {
    return (<div>404 This page does not exist</div>)
}

export default NoPage